import React, { createContext, useContext, useState } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [userDetails, setUserDetails] = useState(() => {
    const User = localStorage.getItem("userDetails") || null;

    return User
      ? JSON.parse(User)
      : {
          userId: null,
          name: null,
          email: null,
          image: null,
          mobile: null,
          roleName: null,
          roleId: null,
          teamName: null,
          teamId: null,
          itemArr: [],
        };
  });

  return <AuthContext.Provider value={{ userDetails, setUserDetails }}>{children}</AuthContext.Provider>;
};
export const useAuth = () => {
  return useContext(AuthContext);
};

export const checkPermission = (authUser, levelName, permissionKey) => {
  try {
    let accessLevelFetch = authUser?.userDetails?.accessLevel;
    let accessLevel = null;
    if (accessLevelFetch) {
      accessLevel = accessLevelFetch;
    } else {
      accessLevel = [];
    }
    const hasPermission = (accessLevel, levelName, permissionKey) => {
      const level = accessLevel.find((item) => item.levelName === levelName);
      return level ? level.permissions.includes(permissionKey) : false;
    };
    return hasPermission(accessLevel, levelName, permissionKey);
  } catch (err) {
    console.log("Error", err.message);
    return false;
  }
};
export const getKeyDetails = (authUser, key) => {
  try {
    let keyFetch = authUser?.userDetails;
    let getKey = null;
    if (keyFetch) {
      getKey = keyFetch[key];
    } else {
      getKey = null;
    }
    return getKey;
  } catch (err) {
    console.log("Error", err.message);
    return null;
  }
};
